import { render, staticRenderFns } from "./NewCountry.vue?vue&type=template&id=b020fe8a&"
import script from "./NewCountry.vue?vue&type=script&lang=js&"
export * from "./NewCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports